module.exports = __webpack_public_path__ + "static/media/Aldine-721-BT.e9cafe52.woff";